export default "__VITE_PUBLIC_ASSET__a05014b1__"